import { NoResultFeed } from 'components/legacy/NoResultFeed';
import { ProjectCard } from 'components/cards/ProjectCard/ProjectCard';
import { SimpleFeed } from 'components/legacy/SimpleFeed/SimpleFeed';
import { FeedLoader } from 'components/common/SkeletonLoader/FeedLoader';
import { ShowMoreButton } from 'components/common/buttons/ShowMoreButton';
import { PageInfo, useProjectsQuery } from 'generated/graphql';
import { AllGameFeedProps, GameProject } from './AllGamesFeed.types';

export const AllGamesFeed = ({
  first,
  sortBy,
  pagination,
  tags,
  banner = true,
  query,
  maxEngineVersion = 3,
  minEngineVersion = 3,
}: AllGameFeedProps) => {
  const {
    data = {},
    fetchMore,
    error,
    loading,
  } = useProjectsQuery({
    notifyOnNetworkStatusChange: true,
    variables: {
      first,
      requireRelevancy: true,
      sortBy,
      tags,
      maxEngineVersion,
      minEngineVersion,
      filter: query,
    },
  });

  const games: GameProject[] = [];

  const pageInfo: Partial<PageInfo> = data.projects?.pageInfo || {};

  if (!!data.projects && !error) {
    games.push(...data.projects.edges.map(({ node }) => node));
  }

  const loadMoreEntries = async () => {
    await fetchMore({
      variables: {
        first,
        cursor: pageInfo.endCursor,
        requireRelevancy: true,
        tags,
        filter: query,
        maxEngineVersion,
        minEngineVersion,
      },
    });
  };

  if (error) {
    return null;
  }

  return (
    <>
      {!loading && games.length < 1 && <NoResultFeed tab="Worlds" />}

      {loading && <FeedLoader quantity={first} />}

      <SimpleFeed banner={banner}>
        {games.map(game => (
          <ProjectCard key={game.id} project={game} dataCy={`GameCard${games.indexOf(game)}`} />
        ))}
      </SimpleFeed>
      {pagination && pageInfo.hasNextPage && (
        <div className="flex justify-center mt-4">
          <ShowMoreButton loading={loading} onClick={loadMoreEntries} />
        </div>
      )}
    </>
  );
};
